import { render, staticRenderFns } from "./vuecommadl5.vue?vue&type=template&id=cd2c9788&scoped=true"
import script from "./vuecommadl5.vue?vue&type=script&lang=js"
export * from "./vuecommadl5.vue?vue&type=script&lang=js"
import style0 from "./vuecommadl5.vue?vue&type=style&index=0&id=cd2c9788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2c9788",
  null
  
)

export default component.exports